import { useRef } from 'react';
import {
  arrow as createArrow,
  useFloating,
  UseFloatingReturn,
} from '@floating-ui/react';
import { PopoverNextProps } from '../PopoverNext.types';

const ARROW_HEIGHT_PX = 6;
const ARROW_WIDTH_PX = 12;

const getContentOffset = (
  placement: PopoverNextProps['placement'],
): Record<string, string> => {
  if (!placement || placement.includes('auto')) return {};

  const contentPlacement = placement.split('-')[0].trim() as
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'auto';

  if (contentPlacement === 'auto') return {};

  const cssFieldFor: Record<
    'top' | 'bottom' | 'left' | 'right',
    'top' | 'left'
  > = {
    top: 'top',
    bottom: 'top',
    right: 'left',
    left: 'left',
  };

  const offsetFor: Record<'top' | 'bottom' | 'left' | 'right', number> = {
    top: -ARROW_HEIGHT_PX,
    bottom: ARROW_HEIGHT_PX,
    left: -ARROW_HEIGHT_PX,
    right: ARROW_HEIGHT_PX,
  };

  return {
    [cssFieldFor[contentPlacement]]: `${offsetFor[contentPlacement]}px`,
  };
};

export const useArrow = (showArrow: boolean) => {
  const arrowRef = useRef(null);

  const getArrowProps = (context: UseFloatingReturn['context']) => ({
    ref: arrowRef,
    context,
    width: ARROW_WIDTH_PX,
    height: ARROW_HEIGHT_PX,
  });

  const getContentWithArrowStyles = (
    floatingPlacement: ReturnType<typeof useFloating>['placement'],
  ) => (showArrow ? getContentOffset(floatingPlacement) : {});

  return {
    getArrowProps,
    arrowMiddleware: showArrow
      ? createArrow({
          element: arrowRef,
          padding: 6,
        })
      : undefined,
    getContentWithArrowStyles,
  };
};
